import React, { createContext, useContext, useState } from "react";

const QuoteContext = createContext(null);

export function QuoteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({ service: "", sector: "" });

  const openQuote = (opts = {}) => {
    setPrefill({ service: opts.service || "", sector: opts.sector || "" });
    setOpen(true);
  };

  return (
    <QuoteContext.Provider value={{ open, setOpen, openQuote, prefill }}>
      {children}
    </QuoteContext.Provider>
  );
}

export const useQuote = () => useContext(QuoteContext);
